const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmt = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const rowsHtml = rows
    .map(
      (row) => `
      <tr>
        <td class="text-center">${escapeHtml(row.serialNumber)}</td>
        <td class="text-left">${escapeHtml(row.debitObject).replace(/\n/g, "<br/>")}</td>
        <td class="text-right">${fmt(row.wage)}</td>
        <td class="text-right">${fmt(row.otherAmount)}</td>
        <td class="text-right">${fmt(row.tk334Total)}</td>
        <td class="text-right">${fmt(row.unionFee)}</td>
        <td class="text-right">${fmt(row.socialInsurance)}</td>
        <td class="text-right">${fmt(row.healthInsurance)}</td>
        <td class="text-right">${fmt(row.unemploymentInsurance)}</td>
        <td class="text-right">${fmt(row.tk338Total)}</td>
        <td class="text-right">${fmt(row.tk335Expense)}</td>
        <td class="text-right">${fmt(row.grandTotal)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Bảng phân bổ tiền lương và các khoản trích theo lương</title>
      <style>
        @media print { @page { margin: 8mm; size: landscape; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 12px; color: #000; padding: 12px; }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid #000; padding: 3px 4px; }
        th { text-align: center; font-weight: 700; vertical-align: middle; }
        .text-left { text-align: left; white-space: pre-line; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .header { display: flex; justify-content: space-between; margin-bottom: 8px; }
        .title { text-align: center; font-size: 24px; font-weight: 700; text-transform: uppercase; margin: 8px 0 4px; }
        .sub { text-align: center; margin-bottom: 8px; }
        .meta { text-align: right; margin-bottom: 8px; }
        .signatures { display: flex; justify-content: space-between; margin-top: 34px; text-align: center; align-items: flex-start; }
        .sign-box { width: 44%; position: relative; }
        .sign-date { position: absolute; top: -18px; left: 0; width: 100%; text-align: center; }
        .italic { font-style: italic; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit)}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department)}</div>
        </div>
        <div class="text-center">
          <div><b>Mẫu số: 08 - LĐTL</b></div>
          <div class="italic">(Kèm theo Thông tư số 99/2025/TT-BTC</div>
          <div class="italic">ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      <div class="title">Bảng phân bổ tiền lương và các khoản trích theo lương</div>
      <div class="sub">Tháng ${escapeHtml(headerInfo.month)} năm ${escapeHtml(headerInfo.year)}</div>
      <div class="meta">Số: ${escapeHtml(headerInfo.documentNumber)}</div>

      <table>
        <thead>
          <tr>
            <th rowspan="3">Số TT</th>
            <th rowspan="3">Ghi Có Tài khoản<br/>Đối tượng sử dụng (Ghi Nợ các Tài khoản)</th>
            <th colspan="3">TK 334 - Phải trả người lao động</th>
            <th colspan="5">TK 338 - Phải trả, phải nộp khác</th>
            <th rowspan="3">TK 335<br/>Chi phí phải trả</th>
            <th rowspan="3">Tổng cộng</th>
          </tr>
          <tr>
            <th rowspan="2">Lương</th>
            <th rowspan="2">Các khoản khác</th>
            <th rowspan="2">Cộng Có TK334</th>
            <th rowspan="2">Kinh phí công đoàn</th>
            <th rowspan="2">Bảo hiểm xã hội</th>
            <th rowspan="2">Bảo hiểm y tế</th>
            <th rowspan="2">Bảo hiểm thất nghiệp</th>
            <th rowspan="2">Cộng Có TK338<br/>(3382, 3383, 3384, 3386)</th>
          </tr>
          <tr></tr>
          <tr>
            <th>A</th>
            <th>B</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td></td>
            <td class="text-center"><b>Cộng</b></td>
            <td class="text-right"><b>${fmt(totals.wage)}</b></td>
            <td class="text-right"><b>${fmt(totals.otherAmount)}</b></td>
            <td class="text-right"><b>${fmt(totals.tk334Total)}</b></td>
            <td class="text-right"><b>${fmt(totals.unionFee)}</b></td>
            <td class="text-right"><b>${fmt(totals.socialInsurance)}</b></td>
            <td class="text-right"><b>${fmt(totals.healthInsurance)}</b></td>
            <td class="text-right"><b>${fmt(totals.unemploymentInsurance)}</b></td>
            <td class="text-right"><b>${fmt(totals.tk338Total)}</b></td>
            <td class="text-right"><b>${fmt(totals.tk335Expense)}</b></td>
            <td class="text-right"><b>${fmt(totals.grandTotal)}</b></td>
          </tr>
        </tbody>
      </table>

        <div class="signatures">
          <div class="sign-box">
            <b>Người lập bảng</b><br/>
            <span class="italic">(Ký, họ tên)</span>
          </div>
          <div class="sign-box">
            <div class="sign-date italic">Ngày....tháng....năm....</div>
            <b>Kế toán trưởng</b><br/>
            <span class="italic">(Ký, họ tên)</span>
          </div>
        </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
